import moment from "moment";
import utilTranslations from "helpers/utilTranslations";

class MomentjsI18n {
  constructor() {
    this.lang = "de";
    this.format = "YYYY/MM/DD";
    this.updateLocale();
  }

  setFormat = (format) => {
    this.format = format;
    this.updateLocale();
  };

  setLang = (lang) => {
    this.lang = lang;
    this.updateLocale();
  };

  updateLocale = () => {
    moment.updateLocale(this.lang, this.getLocale());
    moment.locale(this.lang);
  };

  getLocale = () => {
    const translate = utilTranslations(this.lang, "moment");
    const meridiem = translate("meridiem");
    const ordinal = translate("ordinal");

    return {
      months: translate("months"),
      monthsShort: translate("monthsShort"),
      monthsParseExact: true,
      weekdays: translate("weekdays"),
      weekdaysShort: translate("weekdaysShort"),
      weekdaysMin: translate("weekdaysMin"),
      weekdaysParseExact: true,
      longDateFormat: {
        ...translate("longDateFormat"),
        L: this.format,
      },
      calendar: translate("calendar"),
      relativeTime: translate("relativeTime"),
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: (number) => number + (number === 1 ? ordinal.one : ordinal.other),
      meridiemParse: new RegExp(`${meridiem.am}|${meridiem.pm}`),
      isPM: (input) => input === meridiem.pm,
      meridiem: (hours) => {
        return hours < 12 ? meridiem.am : meridiem.pm;
      },
      week: translate("week"),
    };
  };
}

export default new MomentjsI18n();
